export default __webpack_public_path__ + "static/media/twint-icon-camera.85c74fc0.svg";